import { useState, useEffect, useRef } from 'react';
import { useDebouncedEffect } from '../CustomHooks';
import styles from './StrengthsExpandable.module.scss';
import { Icon } from '@iconify/react';
import bxsRightArrow from '@iconify-icons/bx/bxs-right-arrow';

interface Props {
  title: string;
  description: string;
}

const StrengthsExpandable = ({ title, description }: Props): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [textHeight, setTextHeight] = useState('0px');

  const contentRef = useRef<HTMLDivElement>(null);
  const handleClick = () => {
    setIsExpanded(!isExpanded);
    setTextHeight(isExpanded || contentRef.current === null ? '0px' : `${contentRef.current.scrollHeight}px`);
  };

  const handleResize = () => {
    const newTextHeight = !isExpanded || contentRef.current === null ? `0px` : `${contentRef.current.scrollHeight}px`;
    setTextHeight(newTextHeight);
  };

  useDebouncedEffect(() => window.addEventListener('resize', handleResize), [handleResize], 1000);

  useEffect(() => {
    if (isExpanded) setTextHeight(`${contentRef.current?.scrollHeight}px`);
  }, [title, description]);

  return (
    <div className={styles.container} style={{ paddingBottom: isExpanded ? '1em' : 0 }}>
      <div className={styles.title} onClick={handleClick} role='button'>
        <h3>What is {title}?</h3>
        <div>
          <Icon icon={bxsRightArrow} width={16} height={16} rotate={isExpanded ? '90deg' : ''} color='#00afd8' />
        </div>
      </div>
      <div className={styles.accordionText} ref={contentRef} style={{ maxHeight: `${textHeight}` }}>
        <div
          className={styles.contentContainer}
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </div>
    </div>
  );
};

export default StrengthsExpandable;
